import { useLocalStorage } from '@vueuse/core'
import { createI18n } from 'vue-i18n'

import enUS from './en-US'
import zhCN from './zh-CN'

export type MessageSchema = typeof zhCN

const localeStorage = useLocalStorage<'zh-CN' | 'en-US'>('locale', 'en-US')

const i18n = createI18n<[MessageSchema], 'zh-CN' | 'en-US'>({
  legacy: false,
  locale: (() => {
    // Try to get saved locale from localStorage
    const saved = localeStorage.value
    if (saved === 'zh-CN' || saved === 'en-US') {
      return saved
    }

    // Fallback to browser language
    const browserLang = navigator.language || navigator.languages?.[0] || 'en-US'
    if (browserLang.startsWith('zh')) {
      return 'zh-CN'
    }
    return 'en-US'
  })(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

export default i18n

// Helper function to set locale and save to localStorage
export function setLocale(locale: 'zh-CN' | 'en-US') {
  // Only update if locale is actually changing to avoid unnecessary updates
  const currentLocale = (i18n.global as any).locale.value
  if (currentLocale === locale) {
    return
  }

  // Update i18n locale (this triggers reactive updates in components)
  ;(i18n.global as any).locale.value = locale

  // Update localStorage synchronously
  // Note: useLocalStorage from @vueuse/core should not trigger page reload
  localeStorage.value = locale
}

// Helper function to get current locale
export function getLocale(): 'zh-CN' | 'en-US' {
  return (i18n.global as any).locale.value as 'zh-CN' | 'en-US'
}
